module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.fc78759.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Medium.woff
// module id = 316
// module chunks = 1